<template>
  <div class="contract_item-container">
    <div class="contract-status">
      <b-badge v-if="!noStatus" :variant="contract.contractStatusId === $options.ContractStatuses.APPROVED.id ? 'success'  : 'warning'"> 
        {{ $options.ContractStatuses.getName(contract.contractStatusId)  }} 
      </b-badge>
      <!-- <b-badge class="mt-1 billed-badge" v-if="contract.isBilled" variant="warning"> 
        Billed
      </b-badge>  -->
    </div>
    <div class="contract-no">{{ contract.contractNo }}</div>
    <div class="tradename">{{ contract.tradeName }}</div>
    <div class="tin">{{ contract.tin }}</div>
  </div>
</template>

<script>
import { ContractStatuses } from '../../helpers/enum'
export default {
  ContractStatuses,
  props: {
    contract: {
      type: Object,
      default: null
    },
    noStatus: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .contract_item-container {
    width: 100%;
    position: relative;
    padding: 5px;
  }

  .contract-status {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    flex-direction: column;
  }

  .contract-no {
    font-size: 8pt;
    //color: gray;
  }

  .tin {
    font-size: 8pt;
    //color: gray;
  }

  .billed-badge {
    opacity: 0.6
  }
</style>